// extracted by mini-css-extract-plugin
export default {"separator":"TeamTab_separator__gSDQ3","memberName":"TeamTab_memberName__Ya6hI"};